module.exports = __webpack_public_path__ + "static/media/user_select.6df6f0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/user_select.png
// module id = 645
// module chunks = 2